import { render, staticRenderFns } from "./AddCamionModal.vue?vue&type=template&id=19169743&"
import script from "./AddCamionModal.vue?vue&type=script&lang=ts&"
export * from "./AddCamionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports